export enum sectionsRefer {
  solutions = 'solutions',
  projects = 'projects',
  providers = 'providers',
  company = 'company',
}
